<div fxLayout="column" style="width: 100%;">
    <!-- <button [attr.guide]="'create-campaign-template-btn-1' + '__' + sanitizedUrl" (click)="patchJson()">Patch JSON</button> -->
    <!-- Hide header when coming from sequence -->
    <div *ngIf="!fromSequence" class="header-container" fxLayout="row" fxLayoutAlign="space-between center"
        style="background: #f7f7f7; padding: 16px; border-bottom: 1px solid #ccc;">
        <div fxFlex="20" class="title-text">
            <span>
                <h3>Create Campaign Template</h3>
            </span>
        </div>

        <div fxFlex="50">

        </div>

        <div fxFlex fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button [attr.guide]="'create-campaign-template-btn-2' + '__' + sanitizedUrl" mat-stroked-button
                color="primary" (click)="backtotemplates()">Back to Templates</button>
            <!-- <button [attr.guide]="'create-campaign-template-btn-3' + '__' + sanitizedUrl" mat-flat-button color="accent" (click)="edittemplateOnmeta()">Edit this Template on Meta</button> -->
            <button (click)="whatsappCampaign()" [attr.guide]="'create-campaign-template-btn-4' + '__' + sanitizedUrl"
                mat-stroked-button color="primary">Manage Campaign</button>
        </div>
    </div>

    <div>

        <form [formGroup]="templateForm" class="template-form">

            <div class="campaign-form-container">

                <div class="form-column">

                    <!-- Hide Step 1 when coming from sequence -->
                    <div class="step-section" *ngIf="!fromSequence">
                        <h3 class="step-title">Step 1</h3>

                        <div class="template-info template-section">
                            <!-- Hide template selection when coming from sequence -->
                            <div *ngIf="!isTemplateSelected && !fromSequence" class="template-selection-section">
                                <div class="select-label">Select Template</div>
                                <mat-form-field appearance="outline" class="template-select">
                                    <mat-label>Choose a template</mat-label>
                                    <input [attr.guide]="'create-campaign-template-inp-template' + '__' + sanitizedUrl"
                                        type="text" matInput [formControl]="templateSearchControl"
                                        [matAutocomplete]="templateAuto" (input)="onTemplateSearchInput($event)"
                                        placeholder="Search template by name or language"
                                        [readonly]="isTemplateSelected" />
                                    <mat-autocomplete #templateAuto="matAutocomplete"
                                        (closed)="onTemplateAutocompleteClosed()">
                                        <mat-option (onSelectionChange)="onTemplateSelected($event, template)"
                                            *ngFor="let template of filteredTemplateNames"
                                            [value]="getTemplateSearchLabel(template)">
                                            {{template.templateName || template.name}}
                                            <span *ngIf="template.language || template.languageCode">
                                                - {{template.language || template.languageCode}}
                                            </span>
                                        </mat-option>
                                        <mat-option *ngIf="templateSearchLoading" disabled>
                                            Searching templates...
                                        </mat-option>
                                        <mat-option
                                            *ngIf="!templateSearchLoading && noTemplateSearchResults && (templateSearchControl.value || '').toString().trim().length > 0"
                                            disabled>
                                            No results found
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon *ngIf="isTemplateSelected" matSuffix (click)="backtotemplateSelection()"
                                        style="cursor: pointer; margin-left:8px;">clear</mat-icon>
                                    <mat-error *ngIf="templateSearchControl.hasError('required')">
                                        Template is required
                                    </mat-error>
                                </mat-form-field>
                            </div>


                            <ng-container *ngIf="init">
                                <!-- Hide template preview when coming from sequence -->
                                <div *ngIf="isTemplateSelected && selectedTemplate && !fromSequence"
                                    class="template-container">
                                    <div class="template-header">
                                        <span class="template-label">Template</span>
                                        <button [attr.guide]="'create-campaign-template-btn-5' + '__' + sanitizedUrl"
                                            mat-button (click)="backtotemplateSelection()"
                                            class="change-button">Change</button>
                                    </div>
                                    <div class="template-info">
                                        <div class="template-name">{{selectedTemplate.name}}</div>
                                        <div class="template-meta">
                                            <span>Language Code: {{selectedTemplate.language}}</span>
                                            <span>Category: {{selectedTemplate.category}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>


                        </div>

                        <div *ngIf="bodyVariables.length > 0" class="body-variables-section">
                            <h4 class="section-title">Body</h4>

                            <div *ngFor="let variable of bodyVariables; let i = index" class="variable-input-group">
                                <label class="variable-label">Assign content for {{variable.textVariable}}
                                    variable</label>
                                <div class="variable-options">
                                    <button [attr.guide]="'create-campaign-template-btn-6' + '__' + sanitizedUrl"
                                        type="button" class="btn btn-option"
                                        *ngFor="let option of getVariableOptions(i)"
                                        (click)="selectVariableOption(i, option)">
                                        {{option}}
                                    </button>
                                </div>
                                <input [attr.guide]="'create-campaign-template-inp-7' + '__' + sanitizedUrl" type="text"
                                    class="form-input variable-input" [formControlName]="'exampleBodyField_' + i"
                                    placeholder="Choose or Write your own" />
                            </div>
                        </div>
                        <div class="step-section"
                            *ngIf="showDynamicVariable ||  showButtonVariables || showMediaUpload">
                            <div *ngIf="showDynamicVariable" class="dynamic-variables-section">
                                <div class="variables-header">Template Variables</div>
                                <div *ngFor="let varNumber of variables" class="variable-input">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Value for {{varNumber}}</mat-label>
                                        <input [attr.guide]="'create-campaign-template-inp-8' + '__' + sanitizedUrl"
                                            matInput [(ngModel)]="variableValues[varNumber]"
                                            [ngModelOptions]="{standalone: true}" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div *ngIf="showButtonVariables" class="button-variables-section">
                                <div class="variables-header">Button Variables</div>

                                <!-- URL Button Variables -->
                                <div *ngFor="let button of urlButtons" class="button-variable-group">
                                    <div class="button-title">{{button.text}} (URL)</div>
                                    <div class="button-url-preview">URL: {{button.url}}</div>
                                    <div *ngFor="let variable of button.variables" class="variable-input">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Value for {{variable}}</mat-label>
                                            <input [attr.guide]="'create-campaign-template-inp-9' + '__' + sanitizedUrl"
                                                matInput [(ngModel)]="buttonVariableValues[button.key][variable]"
                                                [ngModelOptions]="{standalone: true}" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- COPY_CODE Button Variables -->
                                <div *ngFor="let button of copyCodeButtons" class="button-variable-group">
                                    <div class="button-title">{{button.text}} (Copy Code)</div>
                                    <div class="button-example">Example: {{button.example}}</div>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Value for {{button.text}}</mat-label>
                                        <input [attr.guide]="'create-campaign-template-inp-10' + '__' + sanitizedUrl"
                                            matInput [(ngModel)]="buttonVariableValues[button.key]"
                                            [ngModelOptions]="{standalone: true}" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <!-- In your template -->
                            <div *ngIf="showMediaUpload" class="media-upload-section">
                                <div class="media-header">
                                    <div class="header-info">
                                        <div *ngIf="headerMediaType !== 'DOCUMENT'" class="media-type-label">
                                            {{headerMediaType}} Header</div>
                                        <div *ngIf="headerMediaType !== 'DOCUMENT'" class="required-note">Upload a new
                                            file or keep the existing one</div>
                                    </div>
                                    <button [attr.guide]="'create-campaign-template-btn-11' + '__' + sanitizedUrl"
                                        mat-stroked-button class="update-button" (click)="toggleMediaUpload()"
                                        style="margin-bottom: 1rem;">
                                        {{showMediaUploadControls ? 'Cancel' : 'Upload New Media'}}
                                    </button>
                                </div>

                                <!-- Show existing media preview when no new media uploaded -->
                                <div *ngIf="!isMediaUploaded && originalHeaderMediaUrl && headerMediaType !== 'DOCUMENT'"
                                    class="existing-media-preview"
                                    style="margin: 10px 0; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
                                    <div style="font-size: 0.85em; color: #555; margin-bottom: 6px;">Current media (will
                                        be reused if no new file uploaded):</div>
                                    <img *ngIf="headerMediaType === 'IMAGE'" [src]="originalHeaderMediaUrl"
                                        style="max-width: 200px; max-height: 120px; border-radius: 4px; object-fit: cover;"
                                        alt="Existing header image">
                                    <video *ngIf="headerMediaType === 'VIDEO'" controls
                                        style="max-width: 200px; max-height: 120px;">
                                        <source [src]="originalHeaderMediaUrl" type="video/mp4">
                                    </video>
                                    <!-- <a *ngIf="headerMediaType === 'DOCUMENT'" [href]="originalHeaderMediaUrl"
                                        target="_blank" style="color: #1976d2;">View Current Document</a> -->
                                </div>

                                <div *ngIf="showMediaUploadControls" class="upload-controls">
                                    <!-- Image Upload -->
                                    <div *ngIf="headerMediaType === 'IMAGE'">
                                        <calsoft-whatsapp-image fxFlex="50" fxFlex.lt-md="100"
                                            style="padding-bottom: 10px;" [finalValue]="fileNameNew" required
                                            (sendValue)="handleMediaUpload($event, 'image')">
                                        </calsoft-whatsapp-image>
                                    </div>

                                    <!-- Video Upload -->
                                    <div *ngIf="headerMediaType === 'VIDEO'">
                                        <calsoft-whatsapp-video fxFlex="50" fxFlex.lt-md="100"
                                            [finalValue]="fileNameNew" (sendValue)="handleMediaUpload($event, 'video')">
                                        </calsoft-whatsapp-video>
                                    </div>

                                    <!-- Document Upload -->
                                    <div *ngIf="headerMediaType === 'DOCUMENT'">
                                        <calsoft-whatsapp-pdf fxFlex="40" fxFlex.lt-md="100" fxFlex.xs="100"
                                            style="padding-bottom: 10px;" [finalValue]="fileNameNew"
                                            (sendValue)="handleMediaUpload($event, 'document')">
                                        </calsoft-whatsapp-pdf>
                                    </div>

                                    <!-- Uploaded Media Preview -->
                                    <div *ngIf="isMediaUploaded" class="uploaded-preview"
                                        style="margin-top: 15px; padding: 10px; border: 1px solid #eee; border-radius: 4px; background: #fafafa;">
                                        <div class="preview-label"
                                            style="font-weight: 500; font-size: 0.9em; margin-bottom: 8px;">Uploaded
                                            Media Preview:</div>
                                        <div *ngIf="uploadedMediaUrl">
                                            <img *ngIf="headerMediaType === 'IMAGE'" [src]="uploadedMediaUrl"
                                                class="preview-image"
                                                style="max-width: 200px; max-height: 120px; border-radius: 4px; object-fit: cover;">
                                            <video *ngIf="headerMediaType === 'VIDEO'" controls class="preview-video"
                                                style="max-width: 200px; max-height: 120px;">
                                                <source [src]="uploadedMediaUrl" type="video/mp4">
                                            </video>
                                            <a *ngIf="headerMediaType === 'DOCUMENT'" [href]="uploadedMediaUrl"
                                                target="_blank" class="document-link"
                                                style="color: #1976d2; text-decoration: underline;">View Uploaded
                                                Document</a>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="mediaRequiredError" class="error-message">
                                    Please upload a new {{headerMediaType}} file before sending
                                </div>
                            </div>
                        </div>
                        <!-- Add this in Step 1 section after media upload section -->
                        <div *ngIf="showLocationFields" class="body-variables-section">
                            <h4 class="section-title">Location Details</h4>

                            <div class="variable-input-group">
                                <label class="variable-label">Assign content for <strong>Location Latitude</strong>
                                    variable</label>
                                <div class="variable-options">
                                    <button [attr.guide]="'create-campaign-template-btn-12' + '__' + sanitizedUrl"
                                        type="button" class="example-field-button"
                                        (click)="setLocationExample('latitude')">
                                        Use Example
                                    </button>
                                </div>
                                <input
                                    [attr.guide]="'create-campaign-template-inp-locationlatitude' + '__' + sanitizedUrl"
                                    type="text" class="form-input variable-input" formControlName="locationLatitude"
                                    placeholder="Choose or Write your own" />
                            </div>

                            <div class="variable-input-group">
                                <label class="variable-label">Assign content for <strong>Location Longitude</strong>
                                    variable</label>
                                <div class="variable-options">
                                    <button [attr.guide]="'create-campaign-template-btn-13' + '__' + sanitizedUrl"
                                        type="button" class="example-field-button"
                                        (click)="setLocationExample('longitude')">
                                        Use Example
                                    </button>
                                </div>
                                <input
                                    [attr.guide]="'create-campaign-template-inp-locationlongitude' + '__' + sanitizedUrl"
                                    type="text" class="form-input variable-input" formControlName="locationLongitude"
                                    placeholder="Choose or Write your own" />
                            </div>

                            <div class="variable-input-group">
                                <label class="variable-label">Assign content for <strong>Location Name</strong>
                                    variable</label>
                                <div class="variable-options">
                                    <button [attr.guide]="'create-campaign-template-btn-14' + '__' + sanitizedUrl"
                                        type="button" class="example-field-button" (click)="setLocationExample('name')">
                                        Use Example
                                    </button>
                                </div>
                                <input [attr.guide]="'create-campaign-template-inp-locationname' + '__' + sanitizedUrl"
                                    type="text" class="form-input variable-input" formControlName="locationName"
                                    placeholder="Choose or Write your own" />
                            </div>

                            <div class="variable-input-group">
                                <label class="variable-label">Assign content for <strong>Location Address</strong>
                                    variable</label>
                                <div class="variable-options">
                                    <button [attr.guide]="'create-campaign-template-btn-15' + '__' + sanitizedUrl"
                                        type="button" class="example-field-button"
                                        (click)="setLocationExample('address')">
                                        Use Example
                                    </button>
                                </div>
                                <input
                                    [attr.guide]="'create-campaign-template-inp-locationaddress' + '__' + sanitizedUrl"
                                    type="text" class="form-input variable-input" formControlName="locationAddress"
                                    placeholder="Choose or Write your own" />
                            </div>
                        </div>
                    </div>



                    <div *ngIf="type!=2" class="step-section">
                        <!-- Hide title when coming from sequence -->
                        <h3 class="step-title" *ngIf="!fromSequence">Step 2</h3>

                        <div class="campaign-section">
                            <!-- Hide section title when coming from sequence -->
                            <h4 class="section-title" *ngIf="!fromSequence">Contacts and Schedule</h4>

                            <!-- Show Notes when coming from sequence, otherwise show Campaign Title -->
                            <div class="form-group">
                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>{{ fromSequence ? 'Notes' : 'Campaign Title' }}</mat-label>
                                    <input
                                        [attr.guide]="'create-campaign-template-inp-campaigntitle' + '__' + sanitizedUrl"
                                        matInput formControlName="campaignTitle" [required]="!fromSequence"
                                        trim="blur" />
                                    <mat-error
                                        *ngIf="templateForm.get('campaignTitle')?.hasError('required') && (templateForm.get('campaignTitle')?.touched)">
                                        {{ fromSequence ? 'Notes' : 'Campaign Title' }} is required
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Recipient Type selection (hidden when coming from leads or sequence) -->
                            <div class="form-group" *ngIf="!fromLeads && !fromSequence">
                                <mat-form-field appearance="outline" class="template-select" fxFlex="100">
                                    <mat-label>Recipient Type</mat-label>
                                    <mat-select formControlName="recipientType"
                                        (selectionChange)="onRecipientTypeChange($event.value)">
                                        <mat-option value="contact">Contact</mat-option>
                                        <mat-option value="lead">Lead</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- Lead Selection Group (hidden when coming from leads or sequence) -->
                            <div class="form-group"
                                *ngIf="!fromLeads && !fromSequence && templateForm.get('recipientType')?.value === 'lead'"
                                fxLayout="column" fxLayoutGap="16px">
                                <mat-form-field appearance="outline" class="template-select" fxFlex="100">
                                    <mat-label>Lead Select Type</mat-label>
                                    <mat-select formControlName="leadSelectType"
                                        (selectionChange)="onLeadSelectTypeChange($event.value)">
                                        <mat-option value="all">All Leads</mat-option>
                                        <mat-option value="particular">Particular Leads</mat-option>
                                    </mat-select>
                                </mat-form-field>



                                <mat-accordion
                                    *ngIf="templateForm.get('recipientType')?.value === 'lead' && templateForm.get('leadSelectType')?.value === 'particular'">
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                Lead Filter Options
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>

                                        <div fxLayout="column" fxLayoutGap="16px" style="padding-top: 10px;">

                                            <!-- Lead Owner / Status / Source via filter-list-popup (multiselect) -->
                                            <calsoft-filter-list-popup [filterSelectObj]="campaignLeadFilterSelectObj"
                                                [searchRequired]="false" [displayColumnRequired]="false"
                                                [refreshRequired]="false" [type]="1" [name]="'Lead'"
                                                (filterChangeColumn)="onCampaignLeadFilterChange($event)">
                                            </calsoft-filter-list-popup>

                                            <div *ngIf="isLeadFilterApplied" fxLayout="row"
                                                fxLayoutAlign="flex-end center"
                                                style="margin-top: 10px; margin-bottom: 15px;">
                                                <div style="font-weight: 500; font-size: 14px; color: #2e7d32;">
                                                    Total Matched Leads: {{filteredLeadsCount}}
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>

                            <!-- Show selected phone numbers when coming from leads or sequence -->
                            <div class="form-group" *ngIf="(fromLeads || fromSequence) && leadContactsData.length > 0"
                                fxLayout="column">
                                <label class="form-label">Selected Lead Phone Numbers
                                    ({{leadContactsData.length}})</label>
                                <div class="phone-numbers-display"
                                    style="padding: 10px; background: #f5f5f5; border-radius: 4px; max-height: 150px; overflow-y: auto;">
                                    <div *ngFor="let contact of leadContactsData" style="padding: 4px 0;">
                                        <mat-icon
                                            style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle;">phone</mat-icon>
                                        {{ contact.phoneNumber }}
                                    </div>
                                </div>
                            </div>

                            <!-- Contact Group - Updated to mat-select (hidden when coming from leads or sequence, and Recipient Type is Contact) -->
                            <div class="form-group"
                                *ngIf="!fromLeads && !fromSequence && templateForm.get('recipientType')?.value === 'contact'"
                                fxLayout="column">
                                <mat-form-field appearance="outline" class="template-select" fxFlex="100">
                                    <mat-label>Select a Contact Group</mat-label>
                                    <input required type="text" matInput [formControl]="contactGroupSearchControl"
                                        [attr.guide]="'create-campaign-template-inp-contactgroup' + '__' + sanitizedUrl"
                                        placeholder="Search contact group by title" [matAutocomplete]="groupAuto"
                                        (blur)="onContactAutocompleteClosed()"
                                        [readonly]="selectedContactGroup != null">

                                    <mat-autocomplete #groupAuto="matAutocomplete"
                                        (optionSelected)="onContactSelected($event, $event.option.value)">
                                        <mat-option [value]="'all_contacts'">All Contacts</mat-option>
                                        <mat-option *ngFor="let group of filteredContactGroups"
                                            [value]="group.contactGroupId">
                                            {{group.title}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon *ngIf="selectedContactGroup" matSuffix
                                        (click)="clearContactGroupSelection()" style="cursor: pointer;">clear</mat-icon>

                                    <mat-error
                                        *ngIf="templateForm.get('contactGroup')?.hasError('required') && templateForm.get('contactGroup')?.touched">
                                        Contact Group is required
                                    </mat-error>
                                </mat-form-field>

                                <mat-checkbox
                                    [attr.guide]="'create-campaign-template-chk-restrictlanguage' + '__' + sanitizedUrl"
                                    formControlName="restrictLanguage" class="restrict-checkbox">
                                    Restrict by Language Code - Send only to contacts whose language code
                                    matches with template language code
                                </mat-checkbox>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Schedule</label>
                                <div class="schedule-options">
                                    <div class="form-check">
                                        <input
                                            [attr.guide]="'create-campaign-template-inp-schedulenow' + '__' + sanitizedUrl"
                                            type="radio" class="form-check-input" id="scheduleNow" name="scheduleType"
                                            value="now" [checked]="templateForm.get('scheduleType')?.value === 'now'"
                                            (change)="templateForm.get('scheduleType')?.setValue('now')" />
                                        <label for="scheduleNow" class="form-check-label">Now</label>
                                    </div>

                                    <!-- Hide Later option when coming from sequence task -->
                                    <div class="form-check" *ngIf="!fromSequence">
                                        <input
                                            [attr.guide]="'create-campaign-template-inp-schedulelater' + '__' + sanitizedUrl"
                                            type="radio" class="form-check-input" id="scheduleLater" name="scheduleType"
                                            value="later"
                                            [checked]="templateForm.get('scheduleType')?.value === 'later'"
                                            (change)="templateForm.get('scheduleType')?.setValue('later')" />
                                        <label for="scheduleLater" class="form-check-label">Later</label>
                                    </div>

                                    <!-- Timezone and Date Selection (only shown when 'Later' is selected) -->
                                    <div *ngIf="templateForm.get('scheduleType')?.value === 'later'"
                                        class="schedule-details">
                                        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column"
                                            fxLayoutGap="10px">
                                            <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                                <mat-label>Schedule Date</mat-label>
                                                <input
                                                    [attr.guide]="'create-campaign-template-inp-scheduledate' + '__' + sanitizedUrl"
                                                    [min]="today" [matDatepicker]="followUp"
                                                    formControlName="scheduleDate" matInput />
                                                <mat-datepicker-toggle [for]="followUp"
                                                    matSuffix></mat-datepicker-toggle>
                                                <mat-datepicker #followUp></mat-datepicker>

                                                <mat-error *ngIf="templateForm.controls.scheduleDate.errors?.required">
                                                    Please fill out this field.
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column"
                                            fxLayoutGap="10px">
                                            <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                                <mat-label>Schedule Time</mat-label>
                                                <input
                                                    [attr.guide]="'create-campaign-template-inp-scheduletime' + '__' + sanitizedUrl"
                                                    type="time" formControlName="scheduleTime" matInput />

                                                <mat-error *ngIf="templateForm.controls.scheduleTime.errors?.required">
                                                    Please fill out this field.
                                                </mat-error>

                                            </mat-form-field>
                                        </div>

                                        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column"
                                            fxLayoutGap="10px">
                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>Zone</mat-label>
                                                <mat-select formControlName="timeZone">
                                                    <mat-option *ngFor="let status of zone" [value]="status.value">
                                                        {{status.label}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <mat-error *ngIf="templateForm.controls.scheduleTime.errors?.invalidTime">
                                            Time must be greater than current time.
                                        </mat-error>
                                    </div>
                                </div>
                            </div>


                            <!-- Hide Send using Phone Number when coming from sequence -->
                            <div class="form-group" *ngIf="!fromSequence">
                                <mat-form-field appearance="outline" class="phone-select" fxFlex="100">
                                    <mat-label>Send using Phone Number</mat-label>
                                    <mat-select [(value)]="currentPhoneNUmber"
                                        (selectionChange)="onSenderPhoneChange($event.value)">
                                        <mat-option *ngFor="let phone of senderPhoneNumbers"
                                            [value]="phone.number">{{phone.number}}</mat-option>
                                    </mat-select>

                                </mat-form-field>
                            </div>


                            <div class="form-actions">
                                <!-- <button [attr.guide]="'create-campaign-template-btn-16' + '__' + sanitizedUrl" type="submit" class="btn btn-primary">Schedule Campaign</button> -->
                                <button [attr.guide]="'create-campaign-template-btn-17' + '__' + sanitizedUrl"
                                    [disabled]="text !='Schedule Campaign' || (templateForm.get('recipientType')?.value === 'lead' && templateForm.get('leadSelectType')?.value === 'particular' && filteredLeadsCount === 0)"
                                    (click)="onSubmit()" mat-raised-button>
                                    {{text}}
                                    <mat-icon *ngIf="text !='Schedule Campaign' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="type==2">
                        <div class="preview-container">
                            <h3 class="preview-title">Template Preview</h3>
                            <div class="whatsapp-preview-new">
                                <div class="whatsapp-message">

                                    <div *ngIf="templateForm.get('headerType')?.value && templateForm.get('headerType')?.value !== 'text' && templateForm.get('headerType')?.value != 'location'"
                                        class="message-header">
                                        <div *ngIf="uploadedMediaUrl || originalHeaderMediaUrl"
                                            class="media-preview-new">
                                            <img *ngIf="(uploadedMediaType || headerMediaType?.toLowerCase()) === 'image'"
                                                [src]="uploadedMediaUrl || originalHeaderMediaUrl"
                                                class="preview-media">
                                            <video
                                                *ngIf="(uploadedMediaType || headerMediaType?.toLowerCase()) === 'video'"
                                                controls class="preview-media" [src]="safeHeaderMediaUrl">
                                            </video>
                                            <div *ngIf="(uploadedMediaType || headerMediaType?.toLowerCase()) === 'document'"
                                                class="document-preview">
                                                <i class="fas fa-file-alt"></i>
                                                <span>{{ uploadedMediaFileName || 'View Document' }}</span>
                                            </div>
                                        </div>
                                        <div *ngIf="!uploadedMediaUrl && !originalHeaderMediaUrl"
                                            class="media-placeholder">
                                            <i *ngIf="templateForm.get('headerType')?.value === 'video'"
                                                class="fas fa-play-circle"></i>
                                            <i *ngIf="templateForm.get('headerType')?.value === 'image'"
                                                class="fas fa-image"></i>
                                            <i *ngIf="templateForm.get('headerType')?.value === 'document'"
                                                class="fas fa-file-alt"></i>
                                        </div>
                                    </div>

                                    <div *ngIf="templateForm.get('headerType')?.value === 'location'"
                                        class="location-preview">
                                        <div class="location-info">
                                            <div class="location-name">{{ locationName }}</div>
                                            <div class="location-address">{{ address }}</div>
                                        </div>
                                    </div>

                                    <div *ngIf="templateForm.get('headerType')?.value === 'text'" class="text-header">
                                        {{ templateForm.get('headerTextBody')?.value }}
                                    </div>

                                    <div class="message-body"
                                        [innerHTML]="formatWhatsAppText(templateForm.get('templateBody')?.value)"></div>

                                    <div *ngIf="templateForm.get('templateFooter')?.value" class="message-footer">
                                        {{ templateForm.get('templateFooter')?.value }}
                                    </div>

                                    <div *ngIf="customButtons.data.length > 0" class="message-buttons">
                                        <div *ngFor="let button of customButtons.data; let i = index"
                                            class="button-preview">
                                            <div *ngIf="i < 3" class="button-item">
                                                <i *ngIf="button.buttonType === 'QUICK_REPLY'" class="fas fa-reply"></i>
                                                <i *ngIf="button.buttonType === 'PHONE_NUMBER'"
                                                    class="fas fa-phone-alt"></i>
                                                <i *ngIf="button.buttonType === 'URL_BUTTON' || button.buttonType === 'DYNAMIC_URL_BUTTON'"
                                                    class="fas fa-external-link-alt"></i>
                                                <span *ngIf="button.buttonType === 'COPY_CODE'">
                                                    <i class="fas fa-copy"></i> Copy Code
                                                </span>
                                                <span>{{ button.text }}</span>
                                            </div>
                                        </div>
                                        <div *ngIf="customButtons.data.length > 3" class="see-all-button">
                                            <i class="fas fa-ellipsis-h"></i> See all options
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Hide Template Preview when coming from sequence -->
                <div class="preview-column" *ngIf="!fromSequence">
                    <div class="preview-container">
                        <h3 class="preview-title">Template Preview</h3>
                        <div class="whatsapp-preview">
                            <div class="whatsapp-message">

                                <div *ngIf="templateForm.get('headerType')?.value && templateForm.get('headerType')?.value !== 'text' && templateForm.get('headerType')?.value != 'location'"
                                    class="message-header">
                                    <div *ngIf="uploadedMediaUrl || originalHeaderMediaUrl" class="media-preview">
                                        <img *ngIf="(uploadedMediaType || headerMediaType?.toLowerCase()) === 'image'"
                                            [src]="uploadedMediaUrl || originalHeaderMediaUrl" class="preview-media">
                                        <video *ngIf="(uploadedMediaType || headerMediaType?.toLowerCase()) === 'video'"
                                            controls class="preview-media" [src]="safeHeaderMediaUrl">
                                        </video>
                                        <div *ngIf="(uploadedMediaType || headerMediaType?.toLowerCase()) === 'document'"
                                            class="document-preview">
                                            <i class="fas fa-file-alt"></i>
                                            <span>{{ uploadedMediaFileName || 'View Document' }}</span>
                                        </div>
                                    </div>
                                    <div *ngIf="!uploadedMediaUrl && !originalHeaderMediaUrl" class="media-placeholder">
                                        <i *ngIf="templateForm.get('headerType')?.value === 'video'"
                                            class="fas fa-play-circle"></i>
                                        <i *ngIf="templateForm.get('headerType')?.value === 'image'"
                                            class="fas fa-image"></i>
                                        <i *ngIf="templateForm.get('headerType')?.value === 'document'"
                                            class="fas fa-file-alt"></i>
                                    </div>
                                </div>

                                <div *ngIf="templateForm.get('headerType')?.value === 'location'"
                                    class="location-preview">
                                    <div class="location-info">
                                        <div class="location-name">{{ locationName }}</div>
                                        <div class="location-address">{{ address }}</div>
                                    </div>
                                </div>

                                <div *ngIf="templateForm.get('headerType')?.value === 'text'" class="text-header">
                                    {{ templateForm.get('headerTextBody')?.value }}
                                </div>

                                <div class="message-body"
                                    [innerHTML]="formatWhatsAppText(templateForm.get('templateBody')?.value)"></div>

                                <div *ngIf="templateForm.get('templateFooter')?.value" class="message-footer">
                                    {{ templateForm.get('templateFooter')?.value }}
                                </div>

                                <div *ngIf="customButtons.data.length > 0" class="message-buttons">
                                    <div *ngFor="let button of customButtons.data; let i = index"
                                        class="button-preview">
                                        <div *ngIf="i < 3" class="button-item">
                                            <i *ngIf="button.buttonType === 'QUICK_REPLY'" class="fas fa-reply"></i>
                                            <i *ngIf="button.buttonType === 'PHONE_NUMBER'"
                                                class="fas fa-phone-alt"></i>
                                            <i *ngIf="button.buttonType === 'URL_BUTTON' || button.buttonType === 'DYNAMIC_URL_BUTTON'"
                                                class="fas fa-external-link-alt"></i>
                                            <span *ngIf="button.buttonType === 'COPY_CODE'">
                                                <i class="fas fa-copy"></i> Copy Code
                                            </span>
                                            <span>{{ button.text }}</span>
                                        </div>
                                    </div>
                                    <div *ngIf="customButtons.data.length > 3" class="see-all-button">
                                        <i class="fas fa-ellipsis-h"></i> See all options
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>


</div>